import angular from 'angular';
import './pp/app';
const applistTemplate = require('./mgmt/applist.tpl.html');
const singleAppTemplate = require('./mgmt/singleapp.tpl.html');
angular.module('tkr.custom')
    .decorator('customizationConfig', CustomizationConfigDecorator);
CustomizationConfigDecorator.$inject = ['$delegate'];
function CustomizationConfigDecorator($delegate) {
    const cc = $delegate;
    cc.getAppListTemplate = (appPeriod) => {
        return applistTemplate;
    };
    cc.getSingleAppTemplate = (appPeriod) => {
        return singleAppTemplate;
    };
    return cc;
}
